import { createAction, props } from '@ngrx/store';

import { IQueryStorageItem } from 'app/query-builder/core/query-storage.service';
import { RuleSet } from 'query-builder/query.interfaces';

import { GetEntitiesForMapViewQuery } from 'generated/graphql';

import { SelectedMarkerState } from './entity-map-view.state';

export const NOOP = createAction(
  '[Entity Map View] noop',
  props<{ payload: { ruleSet: RuleSet } }>()
);

export const RUN_QUERY_CLICKED = createAction(
  '[Entity Map View] RUN_QUERY_CLICKED',
  props<{ payload: { ruleSet: RuleSet; campaignId: string } }>()
);

export const RESET_QUERY_CLICKED = createAction(
  '[Entity Map View] RESET_QUERY_CLICKED'
);

export const FETCH_ENTITIES_FOR_MAP_VIEW = createAction(
  '[Entity Map View] FETCH_ENTITIES_FOR_MAP_VIEW',
  props<{ payload: { ruleSet: RuleSet } }>()
);

export const ENTITIES_FETCHED = createAction(
  '[Entity Map View] ENTITIES_FETCHED',
  props<{ payload: GetEntitiesForMapViewQuery }>()
);

export const SET_CURRENT_QUERY = createAction(
  '[Entity Map View] SET_CURRENT_QUERY',
  props<{ payload: IQueryStorageItem }>()
);

export const SET_SELECTED_MARKER = createAction(
  '[Entity Map View] SET_SELECTED_MARKER',
  props<{ payload: SelectedMarkerState }>()
);

export const UPDATE_ENTITY_TAB_CARD_COLLAPSED_STATE = createAction(
  '[Entity Map View] UPDATE_ENTITY_TAB_CARD_COLLAPSED_STATE',
  props<{ entityId: string; isCollapsed: boolean }>()
);

export const UPDATE_ENTITY_TAB_CARD_SELECTED_TAB = createAction(
  '[Entity Map View] UPDATE_ENTITY_TAB_CARD_SELECTED_TAB',
  props<{ entityId: string; tab: 'profile' | 'connections' }>()
);

export const SET_MAP_POSITION = createAction(
  '[Entity Map View] SET_MAP_POSITION',
  props<{ payload: {
    center: [number, number];
    zoom: number;
  }; }>()
);

export const FIT_MAP_TO_BOUNDS = createAction(
  '[Entity Map View] FIT_MAP_TO_BOUNDS'
);

export const RESET_MAP_STATE = createAction(
  '[Entity Map View] RESET_MAP_STATE'
);

export const DATA_LOADING = createAction(
  '[Entity Map View] DATA_LOADING'
);
